module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Shopping/Chart-line#1-e92b9c003a198a688684d2d869a0ebac.svg";